import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import { ADELANTO_CONTRACT_TYPE_ID } from '../../../constants';
import './ContractSelector.scss'; // Optional: keep if styles needed

const ContractSelector = ({
    children,
    contracts,
    setContracts,
    addableContracts,
}) => {
    const [show, setShow] = useState(false);
    const _id = (contracts?.reduce((max, c) => (c._id > max ? c._id : max), 0) ?? 0) + 1;

    return (
        <div className='expandable-link'>
            {show && (
                <div className='expandable-container'>
                    <table className='GreyTable coloreven addcontractstable'>
                        <thead>
                            <tr>
                                <th>{I18n.t('patient.editPatient.contractCard.id')}</th>
                                <th>{I18n.t('patient.editPatient.contractCard.desc')}</th>
                                <th>{I18n.t('patient.editPatient.contractCard.type')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {addableContracts?.map((contract, index) => {
                                const alreadySelected = contracts?.some(
                                    (c) => c.contrato === contract.id,
                                );
                                const isAdelanto =
                                    Number(contract.tipo_contrato) === ADELANTO_CONTRACT_TYPE_ID;
                                const rowDisabled = alreadySelected || !contract.habilitado;
                                return (
                                    <tr
                                        key={index}
                                        onClick={() => {
                                            if (rowDisabled) return;

                                            setContracts([
                                                ...(contracts ?? []),
                                                {
                                                    activo: true,
                                                    value: contract.id,
                                                    contrato: contract.id,
                                                    id: undefined,
                                                    _id,
                                                    descripcion: contract.descripcion,
                                                    tipo_contrato: contract.tipo_contrato,
                                                    tipo_contrato_tipo: contract.tipo_contrato_tipo,
                                                    descripcion_tipo: contract.tipo_contrato_descr,
                                                    subtipo: contract.indicacion_descr,
                                                    indicacion_descr: contract.indicacion_descr,
                                                    obra_social: contract.obra_social,
                                                    productos: contract.productos, // for use in product card
                                                },
                                            ]);

                                            setShow(false);
                                        }}
                                        className={rowDisabled ? 'disabled' : ''}
                                        title={
                                            !contract.habilitado
                                                ? isAdelanto
                                                    ? 'Contrato Adelanto no habilitado (versión inactiva o pendiente de elegibilidad)'
                                                    : 'Contrato no habilitado'
                                                : undefined
                                        }
                                    >
                                        <td>{contract.id}</td>
                                        <td>{contract.descripcion}</td>
                                        <td>
                                            {contract.tipo_contrato_descr}
                                            {isAdelanto ? ' (id 9)' : ''}
                                            {!contract.habilitado ? ' — no habilitado' : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
            <div className='card-rlink' onClick={() => setShow(!show)}>
                {children}
            </div>
        </div>
    );
};

export default ContractSelector;
